module.exports = __webpack_public_path__ + "media/fidelity.754b0804.wav";